export const composeOptimizedImageUrl = (url, width) => {
  if (!url) return ''
  if (/\.svg($|[?#])/i.test(url)) return url
  if (!width) return url

  // do not optimize image loading with existing height query
  if (url.includes('?h=') || url.includes('&h=') || url.includes('/h_')) {
    return url
  }

  const allowedHosts = [
    'images.ctfassets.net',
    'images.unsplash.com',
    'res.cloudinary.com',
  ]

  let parsedUrl
  try {
    parsedUrl = new URL(url)
  } catch {
    return url
  }

  const { host } = parsedUrl

  if (allowedHosts.includes(host)) {
    if (host === 'res.cloudinary.com' && url.includes('/pgahq/image/upload')) {
      const [part1, part2] = url.split('upload')
      return `${part1}upload/w_${width}${part2}`
    }
    // Use real query params — bare URLs must get "?w=" not "&w=" or CDNs return errors.
    if (host === 'images.ctfassets.net' || host === 'images.unsplash.com') {
      if (!parsedUrl.searchParams.has('q')) {
        parsedUrl.searchParams.set('q', '80')
      }
    }
    if (!parsedUrl.searchParams.has('w')) {
      parsedUrl.searchParams.set('w', String(width))
    }
    return parsedUrl.toString()
  }
  return url
}
